import { render, staticRenderFns } from "./XiaoxidetailsRight.vue?vue&type=template&id=9a604f44&scoped=true"
import script from "./XiaoxidetailsRight.vue?vue&type=script&lang=js"
export * from "./XiaoxidetailsRight.vue?vue&type=script&lang=js"
import style0 from "./XiaoxidetailsRight.vue?vue&type=style&index=0&id=9a604f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a604f44",
  null
  
)

export default component.exports